import { CallEvent } from '../types';
import IWebPhoneService from '../IWebPhoneService';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';
import { clearAnswerRequested } from '../lib/callAcceptLatency';

const handleCallEnded = (
  webPhoneService: IWebPhoneService,
  newCallEvent: CallEvent,
  logger: IAppLogger,
) => {
  logger.info(
    `Call ended: ${newCallEvent.callId}`,
    newCallEvent,
    webPhoneService,
  );
  clearAnswerRequested(newCallEvent.callId);
  appManager.events.emit('phone.call.ended', newCallEvent);
};

export default handleCallEnded;
